<template>
  <div class="file-history">
    <div class="his-header">
      <span class="sign">
        <el-checkbox
          v-model="allversion"
          :disabled="noSign"
          @change="showHasSign"
        >{{ $t('已标记') }}</el-checkbox>
      </span>
    </div>

    <div class="his-content">
      <template v-for="(file, index) in fileList">
        <!--组件内部区域-->
        <div
          :key="index"
          class="file-item"
          :class="{'file-active':file.rev == rev || (rev=='' && index==0),
                   'his-content-compare-checked': file.checked }"
        >
          <div class="file-edition">
            <div class="edition">
              {{ file.version }}
            </div>
            <div class="his-content-compare"
                 :class="{'is-not-win-client': ifNotWindowClient,
                 'only-one-version': fileList.length===1
                 }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('加入版本对比')"
                placement="top-start"
                :open-delay="200"
              >
                <el-checkbox v-model="file.checked" @change="handleCheckboxChange(index,file.checked)"></el-checkbox>
              </el-tooltip>
            </div>
          </div>
          <!--操作列表-->
          <div class="file-operation">
            <div class="more">
              <co-menu
                :append-list="dropList(file)"
                name=""
                btn-class="btn-class"
                @click-item="fileOperation(file, $event)"
              >
                <svg
                  slot="btname"
                  class="item-icon item-icon-more"
                >
                  <use xlink:href="#more" />
                </svg>
              </co-menu>
            </div>
          </div>
          <div
            class="files"
            @click="previewFile(index, $event)"
          >
            <div class="title">
              <co-tips
                class="item"
                :content="file.user"
                placement="top"
              >
                <span :class="[file.isNow? 'file-name': 'file-full-name']">{{ file.user }}</span>
              </co-tips>
              <zdocs-defence :fileInfo = file></zdocs-defence>
              <span
                v-show="typeof file.isNow !='undefined'"
                class="is-now"
              >{{ $t('最新') }}</span>
            </div>
            <div class="time">
              <span class="ti">{{ file.modified | formatTime }} {{ $t(formatOp(file.op)) }}</span>
            </div>
            <div
              v-show="file.milestone_desc"
              class="sign-desc"
            >
              <span class="sign-desc-content">{{ file.milestone_desc }}</span>
            </div>
          </div>
        </div>
      </template>
      <div
        v-show="isProject"
        class="is-protect"
      >
        <span class="is-protect-tips">
          {{ $t('该文件处于保护状态，为保障数据安全，暂时无法访问其他历史版本') }}
        </span>
      </div>
    </div>

    <div class="his-footer">
      <p class="his-footer-tip1 s-btn" v-show="filesChecked.length === 1">{{$t('请选择另1个版本进行比较')}}</p>
      <p class="his-footer-tip2 s-btn" v-show="filesChecked.length === 2" @click="handleVersionCompare">{{$t('点击对比2个版本')}}</p>
    </div>
    <!--confirm-->
    <co-confirm
      v-model="confirm.isShow"
      :title="confirm.title"
      :content="confirm.content"
      :sure-btn="confirm.sureButton"
      :only-one="confirm.onlyOne"
      :is-describe="confirm.isDescribe"
      @sure="sureConfirm"
    />

    <!--dialog-->
    <co-dialog
      v-model="dialog.isShow"
      :is-cancel-left="dialog.isCancelLeft"
      :class="dialog.noPadding"
      :title="dialog.title"
      :width="dialog.width"
      :height="dialog.height"
      :sure-btn="dialog.sureButton"
      @close="dialog.isShow = !dialog.isShow"
      @sure="sureConfirm"
    >
      <component
        :is="componentName"
        v-if="dialog.isShow"
        ref="signComment"
        :version-data="curFile"
      />
    </co-dialog>

    <!--toast-->
    <co-toast
      v-model="toast.isShowToast"
      :toast-info="toast.message"
    />

    <!--审批组件-->
    <bs-approval
      ref="bsapproval"
      :other-data="apporvalData"
      :is-third-party="isThirdparty"
    />
  </div>
</template>

<script>
import _$ from 'js/api/getdata'
import {
  formatDate, isClient, _DOC_PERVIEW_PATH, getLanguage, windowClient, ifHasAuth,
} from 'js/util/util.js'
import { bsFileDownLoad } from 'js/api/download/download.js'
import coMenu from 'components/common/menu/index.vue'
import coConfirm from 'components/common/confirm/index.vue'
import coDialog from 'components/common/dialog/index.vue'
import coToast from 'components/common/toast/index.vue'
import coTips from 'components/common/tips/index.vue'
import bsApproval from 'components/business/approval/request-approval.vue'
import bsCommentEl from './comment.vue'
import bsSignEl from './sign.vue'
import isExistPolicy from '../approval/request-approval'
import zdocsDefence from 'components/common/zdocs-defence/zdocs-defence-icon.vue'
import { openUrlInside, compareFile } from '@filez/js-2-native'

const { getData, postData } = require('js/api/getdata').default

export default {
  name: 'Filehistory',
  components: {
    coMenu,
    coConfirm,
    coDialog,
    bsCommentEl,
    bsSignEl,
    coToast,
    coTips,
    bsApproval,
    zdocsDefence,
  },
  filters: {
    /**
         * 格式化时间
         */
    formatTime(value) {
      return formatDate(value, 'yyyy-MM-dd hh:mm')
    },
  },
  props: {
    metaData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ifNotWindowClient: !windowClient(),
      reqParam: {}, // 设置请求的参数
      allversion: false, // 获取全部版本的数据. eg:在标记版本，设为当前，会回到全部版本
      fileList: [], // 历史版本数量最多200个，超过会覆盖
      curFile: {}, // 当前历史文件
      componentName: 'bsCommentEl', // 组件名称
      confirm: { // 确认操作弹窗
        title: '',
        content: '',
        isShow: false,
        sureButton: this.$t('确认'),
        onlyOne: false,
        isDescribe: false,
      },
      dialog: {
        isShow: false,
        width: '450',
        height: '83',
        title: '',
        sureButton: this.$t('添加'),
      },
      toast: {
        isShowToast: false,
        message: {
          info: '',
          tipsType: 'success',
        },
      },
      from: 'ent',
      rev: '',
      noSign: false, // 是否含有标记
      apporvalData: {}, // 发起审批
      paramOther: {},
      currentCheckedIndex: '',
      newest: {},
      isThirdparty: false,
    }
  },
  watch: {
    curRev(n) {
      this.setCurVer(n)
    },
    /**
     * 文件变化初始化列表
     */
    fileData: {
      handler(n) {
        if (n) {
          this.initRevisionList({ neid: n.neid, nsid: n.nsid })
        }
      },
      deep: true,
    },
    /**
         * 监听路由重新设置rev
         */
    $route(to, from) {
      this.rev = this.$route.query.rev || ''
    },
    /**
         * 过滤是否含有标记版本
         */
    fileList(n) {
      const hasSign = n.filter((item, index) => item.milestone_desc != undefined && item.milestone_desc != '')
      this.noSign = !(hasSign.length > 0)
      if (this.allversion && this.noSign) {
        this.allversion = false
        this.initRevisionList(this.reqParam, () => {}, false)
      }
    },
    versionCheckedLen(newValue) {
      if (newValue > 2) {
        this.fileList.forEach((item, index) => {
          if (index !== this.currentCheckedIndex) {
            this.fileList[index].checked = false
          }
        })
      }
    },
  },
  mounted() {
    if (this.fileData) {
      this.initRevisionList({ neid: this.fileData.neid, nsid: this.fileData.nsid })
    }
  },
  created() {
    this.from = this.$route.query.from
    this.neid = this.$route.params.neid
    this.nsid = this.$route.params.nsid
    this.paramOther = JSON.parse((this.$route.query && this.$route.query.other) || '{}')
    this.rev = this.$route.query.rev || ''
  },
  computed: {
    /**
     * 当前选中文件的信息
     */
    fileData() {
      return this.$store.state.curFileInfo
    },
    /**
     * 当前导航版本号
     */
    curRev() {
      return this.$route.query.rev
    },
    filesChecked() {
      return this.fileList.filter((item) => item.checked)
    },
    versionCheckedLen() {
      return this.filesChecked.length
    },
    isProject() {
      return this.fileList.filter((item) => item.protection_status !== 'normal').length > 0
    },
  },
  methods: {
    /**
         * 显示更新/恢复/创建
         */
    formatOp(value) {
      const mapSate = {
        create: '创建',
        update: '更新',
        restore: '恢复',
      }
      return mapSate[value] || ''
    },
    /**
         *  获取资源历史版本记录，并返回当前版本
         */
    initRevisionList(reqParam, callback = '', hasScroll = true) {
      this.reqParam = reqParam
      // 请求历史版本数据
      getData('revisions', reqParam).then((res) => {
        if (res.status === 200) {
          const { content } = res.data
          const fileList = content.length > 200
            ? content.reverse().splice(0, 200)
            : content.reverse()
          this.newest = fileList[0]
          fileList.forEach((item, index) => {
            this.$set(fileList[index],'checked',false)
          })
          this.fileList = fileList
          this.fileList['0'].isNow = true
          this.setCurVer(this.$route.query.rev)
          if (callback != '') callback(this.fileList)
          // 定义位置
          this.$nextTick(() => {
            if (hasScroll) document.querySelector('.file-active').scrollIntoView()
          })
        } else if (callback) {
          callback({
            error: true,
            errormsg: res,
          })
        }
      }).catch((error) => {
        if (callback) {
          callback({
            error: true,
            errormsg: error.response.data,
          })
        }
      })
    },
    /**
         * 修改list列表操作项的名称
         */
    dropList(file) {
      const self = this
      return function () {
        // 设置名称的方法
        function setName(key) {
          return file[key] !== '' && file[key] !== undefined
        }
        // 定义操作
        const operaiton = [ // 操作按钮项
          { name: this.$t('下载'), key: 'download' },
          { name: setName('milestone_desc') ? this.$t('编辑版本标记') : this.$t('标记版本'), key: 'signThem' },
          { name: setName('comment') ? this.$t('查看说明') : this.$t('添加说明'), key: 'addDesc' },
        ]

        // 过滤文件
        if (file.isNow === undefined && !self.isProject) { operaiton.splice(1, 0, { name: this.$t('设为最新版本'), key: 'setNow' }) }
        if (!isClient()) {
          const index = file.isNow ? 1 : 2
          operaiton.splice(index, 0, { name: this.$t('在新标签页打开'), key: 'openNew' })
        }
        if (!ifHasAuth(this.$store.state.curFileInfo.access_mode, 'download')) {
          operaiton.shift()
        }
        return operaiton
      }
    },

    setCurVer(rev) {
      if (this.newest.rev === rev || !rev) {
        this.$store.commit('SET_CUR_VERSIONNUM', '最新')
        return
      }
      this.fileList.map((item) => {
        if (item.rev === rev) {
          this.$store.commit('SET_CUR_VERSIONNUM', item.version)
        }
        return item
      })
    },
    /**
         *显示已标记版本数据
         */
    showHasSign(event) {
      if (this.allversion) {
        this.fileList = this.fileList.filter((item) => typeof item.milestone_desc !== 'undefined' && item.milestone_desc != '')
      } else {
        this.initRevisionList(this.reqParam, () => {}, false)
      }
    },
    privateDownloadFile(file) { // TODO:历史版本下载需要加日志
      const { from } = this.paramOther
      getData('getMetadata', { neid: this.neid, rev: file.rev, from }).then((res) => {
        const content = res.data
        content.rev = file.rev
        const downFile = { isDir: false, content: [content] }
        const { neid, nsid, path } = res.data
        // 查询是否有审批认证后进行下载
        isExistPolicy({ neid, nsid, path }, 'download').then(() => {
          bsFileDownLoad(downFile)
        }).catch((error) => {
          if (error.data) {
            this.apporvalData = {
              approvalType: 'download',
              approvers: error.data,
              neids: [neid],
              nsid,
              path,
              revision: file.rev,
            }
            this.$nextTick(() => {
              _$.getData('isThirdParty').then((res) => {
                if (res.status === 200) {
                  this.isThirdparty = res.data.result
                  this.$refs.bsapproval.show()
                }
              }).catch(() => {
              })
            })
          }
        })
      })
    },
    /**
         * 文件的操作方式
         */
    fileOperation(file, event) {
      // 赋值当前文件
      this.curFile = file
      const { neid, nsid, prefix_neid: prefixNeid, from, path_type: pathType, path } = this.$store.state.curFileInfo
      const { rev } = this.curFile
      switch (event.key) {
        // eslint-disable-next-line no-case-declarations
        case 'download':
          // 调用下载
          this.privateDownloadFile(file)
          break
        case 'setNow':
          this.confirm.title = this.$t('设为最新')
          this.confirm.content = this.$t('确认将{n}版本设为最新版本?', { n: file.version })
          this.confirm.sureButton = this.$t('设为最新')
          this.confirm.isShow = true

          // 改写弹窗方法(设置为当前)
          this.sureConfirm = () => {
            const data = {
              neid,
              rev,
              nsid,
              from,
              target_path: path,
              prefix_neid: prefixNeid,
              path_type: pathType,
            }
            postData('restore', data).then((res) => {
              if (res.status === 200) { // 重新刷新列表
                this.initRevisionList(this.reqParam, (fileList) => {
                  this.$router.push({
                    params: { neid: this.neid },
                    query: {
                      from: this.from,
                      language: getLanguage(),
                      other: this.$route.query.other,
                      rev: fileList['0'].rev,
                    },
                  })
                  this.previewFile(0)
                }, false)
                this.confirm.isShow = false
                this.toast.message.info = this.$t('已设为最新版本')
                this.toast.isShowToast = true
              }
            }).catch((error) => {
              this.toast.message.info = error.response.data.message
              this.toast.message.tipsType = 'warn'
              this.toast.isShowToast = true
            })
          }
          break
          // eslint-disable-next-line no-case-declarations
        case 'openNew':
          const query = { ...this.$route.query }
          query.rev = file.rev
          const { href } = this.$router.resolve({
            query,
          })
          // 跳转界面
          if (isClient()) {
            const params = {}
            if ((window.top.location !== window.location) && this.$store.state.lenovoData.cname && this.$store.state.lenovoData.cname.userdomain) {
              params.url = `http://${this.$store.state.lenovoData.cname.userdomain}${href}`
            } else {
              params.url = `${window.location.protocol}//${window.location.host}${href}`
            }
            params.width = '800'
            params.height = '600'
            params.fullscreen = 'false'
            params.loadingStyle = 'carousel'
            openUrlInside(params)
          } else {
            window.open(href, '_blank')
          }
          break
        case 'signThem':
          this.dialog.title = this.$t('标记版本')
          this.dialog.noPadding = ''
          if (this.curFile.milestone_desc != '' && typeof this.curFile.milestone_desc !== 'undefined') {
            this.dialog.sureButton = this.$t('保存')
          }
          this.componentName = 'bsSignEl'
          this.dialog.width = '450'
          this.dialog.height = '83'
          this.dialog.isCancelLeft = true
          this.dialog.isShow = true
          // 改写弹窗方法(更新版本)
          this.sureConfirm = () => {
            // 定义请求对象
            const data = {
              neid: this.reqParam.neid,
              rev: this.curFile.rev,
              op: 'op_milestone',
              milestone: 0,
            }
            // 更新
            data.milestone_desc = this.$refs.signComment.milestone_desc
            data.milestone = 1
            postData('updateRevisions', data).then((res) => {
              if (res.status == 200) {
                this.curFile.milestone_desc = data.milestone_desc
                if (this.allversion) {
                  this.fileList = this.fileList.filter((item) => typeof item.milestone_desc !== 'undefined' && item.milestone_desc != '')
                }
                this.fileList = Object.assign([], this.fileList) // 让对象属性的更新可以被computed获取到
              }
            }).catch((error) => {
              this.toast.message.info = error.response.data.message
              this.toast.message.tipsType = 'warn'
              this.toast.isShowToast = true
            })
          }
          break
        case 'addDesc':
          this.dialog.title = this.$t('版本说明:')
          this.componentName = 'bsCommentEl'
          this.dialog.width = '520'
          this.dialog.height = '284'
          this.dialog.sureButton = this.$t('确认')
          this.dialog.isCancelLeft = false
          this.dialog.isShow = true
          // 改写弹窗确认方法
          this.sureConfirm = () => {
            // 定义提交参数
            const data = {
              neid: this.reqParam.neid,
              rev: this.curFile.rev,
              op: 'op_comment',
              comment: this.$refs.signComment.comment,
            }
            // 比较修改是否相同
            if (this.curFile.comment === data.comment) {
              this.dialog.isShow = false
              return
            }
            // 提交修改数据
            postData('updateRevisions', data).then((res) => {
              if (res.status == 200) {
                // 更新版本说明
                this.curFile.comment = data.comment
                this.fileList = Object.assign([], this.fileList) // 让对象属性的更新可以被computed获取到
                this.$emit('syncDesc', this.curFile)
                this.dialog.isShow = false
              }
            }).catch((error) => {
              this.toast.message.info = error.response.data.message
              this.toast.message.tipsType = 'warn'
              this.toast.isShowToast = true
            })
          }
          break
      }
    },
    /**
         * 确认事件
         */
    sureConfirm() {},

    /**
         * 预览文件路由
         */
    previewFile(index, $event) {
      const targetNode = $event.target.nodeName
      if (targetNode === 'path' || targetNode === 'svg') {
        return
      }
      const newQuery = { ...this.$route.query, rev: this.fileList[index].rev }
      // 因为在原组件内跳转（仅替换）
      this.$router.push({
        query: newQuery,
      })
      this.$emit('click', this.fileList[index])
    },
    /** 更新列表中当前查看的文件说明 */
    updateListItem(file) {
      this.fileList = this.fileList.map((itemFile, index) => (itemFile.rev == file.rev ? file : itemFile))
    },
    approvalValidation(itemInfo) {
      return new Promise(((resolve, reject) => {
        const { neid, nsid, path } = itemInfo
        isExistPolicy({ neid, nsid, path }, 'download').then(() => {
          resolve()
        }).catch((error) => {
          if (error.data) {
            reject(error)
          }
        })
      }))
    },
    /* 点击对比2个版本 */
    handleVersionCompare() {
      const filesChecked = JSON.parse(JSON.stringify(this.filesChecked))
      const {
        path,
        path_type: pathType,
        is_dir: isDir,
        from,
        prefix_neid: prefixNeid,
      } = this.$store.state.curFileInfo
      const params = filesChecked.map((item) => {
        const obj = {
          path,
          path_type: pathType,
          is_dir: isDir,
          from,
          prefix_neid: prefixNeid,
        }
        const { rev, version } = item
        obj.rev_index = version.slice(1)
        obj.rev = rev
        return obj
      })
      if(pathType === 'ent'){
        this.approvalValidation(this.paramOther)
          .then(() => {
            compareFile(params)
          }).catch((error) => {
          if (error.data) {
            window.$toast.simpleShow(this.$t('此目录设置了审批规则，禁止对比版本'), 'warn')
          } else {
            window.$toast.simpleShow(error.message, 'warn')
          }
        })
      } else{
        compareFile(params)
      }
    },
    /* 右侧版本复选的change事件 */
    handleCheckboxChange(index, checked) {
      this.currentCheckedIndex = checked ? index : this.currentCheckedIndex
    },
  },
}
</script>

<style lang="less">
.file-history{
  box-sizing: border-box;
  width:300px;
  height:100%;
  background: #FFFFFF;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  /*box-shadow: 0 2px 6px 0 rgba(0,0,0,0.15);*/
  .his-header {
    height:32px;
    line-height: 32px;
    padding: 0 24px;
    .title{
      font-size: 14px;
      color: #282E3D;
      letter-spacing: 0;
    }
    .head-border{
      height:28px;
      border-bottom:1px solid #E8EBEF;
    }
    .sign {
      .el-checkbox__inner {
        border: 1px solid #C1C7CD;
        border-radius: 2px;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label{
        color:#606266 !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #3484f5 !important;
        border-color: #3484f5 !important;
      }
    }
  }
  .his-content-compare{
    .el-checkbox{
      outline: none;
      position: absolute;
      visibility: hidden;
      margin-top: 6px;
      margin-left: 4px;
      padding-left: 22px;
      padding-top: 8px;
      box-sizing: border-box;
      top: 14px;
      left: -18px;
      height: 36px;
      width: 54px;
    }

    .el-checkbox__inner{
      &:after{
        border: 1px solid #fff;
        border-left: 0;
        border-top: 0;
        left: 4px;
        top:1px;
      }
      border-radius: 50%;
    }
  }
  .file-item:hover{
    .his-content-compare{
      &.is-not-win-client,
      &.only-one-version{display: none}
      .el-checkbox{
        visibility: visible;
      }
    }
  }
  .his-footer{
    text-align: center;
    height: 47px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    .his-footer-tip1{
      width: 298px;
      height: 47px;
      background: #85B2FD;
      color: #fff;
      line-height: 47px;
      text-align: left;
      padding-left: 20px;
    }
    .his-footer-tip2{
      width: 260px;
      height: 32px;
      text-align: center;
      color: #fff;
      line-height: 32px;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}

/**------------------file-item样式部分---------------------- */
.his-content {
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
  font-size: 0;
  height: calc(100% - 32px);
  .dorp-down-list-li{
    font-size: 14px;
  }
}

.file-item {
  width: 100%;
  min-height: 62px;
  display: inline-block;
  box-sizing: border-box;
  padding:9px 24px 11px 24px;
  &.his-content-compare-checked{
    &:hover{
      background: #E7F0FF;
    }
    background: #E7F0FF;
    .his-content-compare{
      .el-checkbox{
        visibility: visible;
      }
    }
  }
  .file-edition {
    float: left;
    position: relative;
    .edition {
      background: #E7F0FF;
      border-radius: 2px;
      font-size: 14px;
      color: #282E3D;
      letter-spacing: 0;
      min-width: 34px;
      line-height: 20px;
      height: 20px;
      box-sizing: border-box;
      text-align: center;
      text-transform:uppercase;
      padding: 0px 3px;
      box-sizing: border-box;
    }
  }

  .files {
    overflow: hidden;
    min-width: 20px;
    padding: 0 8px 0 12px;
    box-sizing: border-box;
    cursor: pointer;

    .title {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      height: 20px;
      .file-name{
        max-width: calc(100% - 70px);
        line-height: 20px;
        height: 20px;
        font-size: 14px;
        color: #1b2733;
        border: none;
        letter-spacing: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
      }

      .file-full-name{
        display: inline-block;
        max-width:167px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 16px;
        letter-spacing: 0;
      }
    }

    .is-now {
      border-radius: 2px;
      font-size: 12px;
      color: #FFFFFF;
      letter-spacing: 0;
      margin: 0 0 0 8px;
      display: inline-block;
      background: #0a64fa;
      padding: 2px 4px;
      height: 20px;
      box-sizing: border-box;
      vertical-align: top;
    }

    .time {
      width: 100%;
      margin-top: 8px;
      font-size: 14px;
      color: #637282;
      letter-spacing: 0;
      line-height: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .sign-desc{
      padding: 5px 0 0 0;
    }

    .sign-desc-content {
      height: 20px;
      line-height: 20px;
      box-sizing: border-box;
      padding: 0px 6px;
      font-size: 12px;
      color: #0A64FA;
      border-radius: 2px;
      letter-spacing: 0;
      border: 1px solid #0A64FA;
      display: inline-block;
    }
  }

  .file-operation {
    float: right;
    .more {
      letter-spacing: 0;
      cursor: pointer;
      margin-top:3px;
    }
    .item-icon{
      height: 17px;
      vertical-align: middle;
      position: absolute;
      left: 6px;
      overflow: hidden;
    }
    .item-icon-more{
      width: 15px;
      height: 3px;
      position: absolute;
      left: 4px;
      top: 6px;
    }
  }
}
.is-protect {
  color: #929CA9;
  text-align: center;
  box-sizing: border-box;
  height: calc(100% - 68px);
  position: relative;
  .is-protect-tips{
    font-size: 14px;
    padding: 0 15px;
    position: absolute;
    left: 0;
    transform: translate(0,-50%);
    top: 50%;
  }
}

.btn-class {
  border: none;
  color: #5f6379;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 23px;
  height: 15px;
  box-sizing: border-box;

}

.btn-class:hover{
  background:#E8EBEF
}

.no-padding {
  padding:0px;
}

.file-active {
  background: #F6F7FA 100%;
  //background: #cccccc 100%;
}

.file-item:hover{
  background: #F6F7FA 100%;
  //background: #cccccc 100%;
}

/**修改弹窗款样式*/
.el-tooltip__popper{
  padding: 8px 12px;
  font-size: 12px;
  color: #FFFFFF !important;
  background: #3D464C !important;
  transform: translate(2px, 10px);
}
</style>
